import { useEffect, useState } from "react";
import { api } from "./apiClient";

const FALLBACK = { price_reviewed_cop: 1200000, price_auto_cop: 799000, deliverables: [], title: "Kit Documental" };
let cache = null;
let inflight = null;

export function loadN2Offer(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight || force) {
    inflight = api.get("/public/n2-offer").then(({ data }) => {
      cache = data;
      inflight = null;
      return data;
    }).catch(() => {
      inflight = null;
      return cache || FALLBACK;
    });
  }
  return inflight;
}

export function useN2Offer() {
  const [offer, setOffer] = useState(cache || FALLBACK);
  useEffect(() => {
    let alive = true;
    loadN2Offer().then((o) => alive && setOffer(o));
    return () => { alive = false; };
  }, []);
  return offer;
}
